import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { GlobalStyles } from '@bigcommerce/big-design';
import { theme } from '@bigcommerce/big-design-theme';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import App from './App';

const AppGlobalStyles = createGlobalStyle`
    html,
    body,
    #root,
    .app-wrapper,
    .app {
        height: 100%;
    }
    .app {
        background-color: ${({ theme }) => theme.colors.secondary10};
    }
`;

const root = createRoot(document.getElementById('root'));
root.render(
    
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <GlobalStyles />
                <AppGlobalStyles />
                <App />
            </ThemeProvider>
        </BrowserRouter>
    
);
